import { toDate } from './helpers';

Date.from = toDate

declare global {
	interface DateConstructor {
		from(value: any): Date;
	}
}